import { IAppState } from '../../redux';

export function selectPhotos(state: IAppState): Array<string> {
  return state.offer.photos || [];
}
